import { Cross, Star } from '@components/icons'
import bidapi from 'api/bidapi'
import { AuthContext } from 'contexts/AuthContext'
import BidButton from 'elements/BidButton/BidButton'
import { useRouter } from 'next/router'
import React, { Dispatch, SetStateAction, useContext } from 'react'
import { ItemCardManger } from '..'

type Props = {
  visible: boolean
  id: string
  auctionId: string
  containerStyle?: string
  containerStyleObj?: any
  innerContainerStyle?: string
}

const ItemClosed = ({
  visible,
  auctionId,
  id,
  containerStyle,
  containerStyleObj,
  innerContainerStyle,
}: Props) => {
  const router = useRouter()

  return (
    <div
      className={`transition-opacity duration-200 flex justify-center items-center absolute p-4 w-full  ${
        !visible ? '-z-10' : 'z-40'
      } ${!visible ? ` opacity-0` : 'opacity-100'} ${containerStyle}`}
      style={containerStyleObj}
    >
      <div
        className={`rounded pb-2 overflow-scroll overflow-y-scroll  max-h-full ${innerContainerStyle}`}
      >
        <span className="text-white font-bold">
          This item is no longer available.
        </span>
        <div className="flex flex-col items-center justify-center mt-4">
          <BidButton
            label="View Item"
            theme="blue-dark"
            className="text-align-center content-center"
            callBack={() => {
              router.push(`/${auctionId}/item-detail/${id}`)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default ItemClosed
